// Quantum Safe Vault - Configuration Constants

// Contract Addresses by Network
export const CONTRACT_ADDRESSES = {
  // Testnet
  sepolia: "0x3DCd9531339bdb428831c5057ED981D335AC7A68",

  // Mainnet (when deployed)
  mainnet: "", // TODO: Deploy to mainnet

  // L2 Networks (when deployed)
  polygon: "",
  arbitrum: "",
  optimism: "",
  gnosis: "",

  // Local Development
  localhost: "0x5FbDB2315678afecb367f032d93F642f64180aa3"
} as const;

// Network Configuration
export const SUPPORTED_NETWORKS = {
  1: "mainnet",
  11155111: "sepolia",
  137: "polygon",
  42161: "arbitrum",
  10: "optimism",
  100: "gnosis",
  31337: "localhost"
} as const;

// NIST Post-Quantum Cryptography Security Levels
export const SECURITY_LEVELS = {
  CATEGORY_3: 1, // AES-192 equivalent
  CATEGORY_5: 2  // AES-256 equivalent (recommended)
} as const;

// Algorithm Suite Configurations
export const ALGORITHM_SUITES = {
  [SECURITY_LEVELS.CATEGORY_3]: {
    kemAlgorithm: "ML-KEM-768",
    dsaAlgorithm: "ML-DSA-65",
    hashAlgorithm: "SLH-DSA-SHA2-192f",
    securityBits: 192
  },
  [SECURITY_LEVELS.CATEGORY_5]: {
    kemAlgorithm: "ML-KEM-1024",
    dsaAlgorithm: "ML-DSA-87",
    hashAlgorithm: "SLH-DSA-SHA2-256f",
    securityBits: 256
  }
} as const;

// Safe App Configuration
export const SAFE_APP_CONFIG = {
  name: "Quantum Safe Vault",
  description: "NIST Post-Quantum Cryptography for Safe Wallets",
  iconPath: "/logo.svg",
  safeAppsUrl: "https://quantum-safe-vault.cofoundry.global"
} as const;

// Quantum Encryption Settings
export const QUANTUM_SETTINGS = {
  defaultSecurityLevel: SECURITY_LEVELS.CATEGORY_5,
  proposalExpirationTime: 7 * 24 * 60 * 60, // 7 days in seconds
  keyDerivationRounds: 10000,
  encryptionChunkSize: 1024 * 1024 // 1MB chunks
} as const;

// Gas Limits and Pricing
export const GAS_LIMITS = {
  registerSafe: 100000,
  createProposal: 150000,
  approveProposal: 80000,
  executeEncryption: 200000,
  executeDecryption: 150000
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  WALLET_NOT_CONNECTED: "Please connect your wallet",
  UNSUPPORTED_NETWORK: "Unsupported network. Please switch to Sepolia or Mainnet",
  INSUFFICIENT_BALANCE: "Insufficient balance for transaction",
  SAFE_NOT_REGISTERED: "This Safe is not registered with Quantum Vault",
  PROPOSAL_EXPIRED: "This proposal has expired",
  INSUFFICIENT_SIGNATURES: "Not enough signatures to execute proposal",
  CONTRACT_NOT_FOUND: "Quantum Vault contract not found on this network"
} as const;

// Success Messages
export const SUCCESS_MESSAGES = {
  SAFE_REGISTERED: "Safe successfully registered with Quantum Vault",
  PROPOSAL_CREATED: "Quantum encryption proposal created",
  PROPOSAL_APPROVED: "Proposal approved successfully",
  ENCRYPTION_EXECUTED: "Assets encrypted with quantum-safe algorithms",
  DECRYPTION_EXECUTED: "Assets decrypted successfully"
} as const;

// Development Configuration
export const DEV_CONFIG = {
  enableLogging: process.env.NODE_ENV === "development",
  mockQuantumOperations: false, // Set to true for testing without real crypto
  simulationMode: false // Set to true for UI testing without blockchain calls
} as const;